var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBroadcastWarningWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5 14.695L11.668 2.83a1.934 1.934 0 00-3.336 0L1.5 14.695a1.836 1.836 0 000 1.853 1.902 1.902 0 001.668.952h13.664a1.902 1.902 0 001.918-1.879c0-.325-.086-.645-.25-.926zm-9.125-6.57a.625.625 0 011.25 0v3.125a.625.625 0 01-1.25 0V8.125zM10 15a.938.938 0 110-1.875A.938.938 0 0110 15z",
    fill: "#fff"
  })));
}

export default SvgBroadcastWarningWhite;